import { SaleType } from "gen/company/models_pb"
import { useIdFilter } from "shared-ts/hooks/useFilter"

import { useListSaleTypesQuery } from "features/api/company"

import { useWebFilter, UseWebFilterProps } from "./useWebFilter"

export function useCustomSaleTypeFilter({
  persistInUrl = true,
  initialSelectedOptions = [],
}: Partial<
  Pick<UseWebFilterProps<unknown>, "persistInUrl" | "initialSelectedOptions">
> = {}) {
  const { data } = useListSaleTypesQuery()

  const { filter, selected: selectedSaleTypeIds } = useIdFilter({
    key: "customSaleType",
    label: "Custom sale type",
    values: data?.saleTypes ?? [],
    labelExtractor: (saleType: SaleType) => saleType.name,
    useFilter: (props) =>
      useWebFilter({
        ...props,
        persistInUrl,
        initialSelectedOptions,
      }),
  })

  return { filter, selectedSaleTypeIds }
}
